import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Contractor } from '../../objects/Contractor';
import { ContractorService } from '../../Services/contractor.service';
import { AuthService } from '../../components/services/auth.service';

@Component({
  selector: 'app-contractor-add',
  templateUrl: './contractor-add.component.html',
  styleUrls: ['./contractor-add.component.css']
})
export class ContractorAddComponent {
  isSaving = false;
  imagePreview: string | null = null;

  newContractor: Contractor = {
    id: 0,
    name: '',
    age: 0,
    jobTitle: '',
    cellPhone: '',
    email: '',
    salary: 0,
    hourlyWage: 0,
    imageContent: '',
    providerId: undefined
  };

  constructor(
    private router: Router,
    private contractorService: ContractorService,
    private authService: AuthService
  ) {
    const user = this.authService.getCurrentUser();
    if (user?.role === 'provider' || user?.role === 'admin') {
      this.newContractor.providerId = user.id;
    }
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) { return; }
    this.compressImage(file).then(compressed => {
      this.imagePreview = compressed;
      this.newContractor.imageContent = compressed;
    });
  }

  clearPhoto(): void {
    this.imagePreview = null;
    this.newContractor.imageContent = '';
  }

  private compressImage(file: File, maxPx = 240, quality = 0.75): Promise<string> {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const ratio = Math.min(maxPx / img.width, maxPx / img.height, 1);
          const w = Math.round(img.width * ratio);
          const h = Math.round(img.height * ratio);
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          canvas.getContext('2d')!.drawImage(img, 0, 0, w, h);
          resolve(canvas.toDataURL('image/jpeg', quality));
        };
        img.src = e.target!.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  initials(name: string): string {
    if (!name) { return '?'; }
    const parts = name.trim().split(' ');
    return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
  }

  saveContractor(): void {
    this.isSaving = true;
    this.contractorService.addContractor(this.newContractor).subscribe({
      next: () => this.router.navigate(['/contractors']),
      error: () => { this.isSaving = false; }
    });
  }
}
